var map = {
	"./MinimisedEvent": [
		1020,
		9,
		597
	],
	"./MinimisedEvent.js": [
		1020,
		9,
		597
	],
	"./MinimisedEvent.scss": [
		1634,
		7,
		1049
	],
	"./MinimisedResearch": [
		1021,
		9,
		598
	],
	"./MinimisedResearch.js": [
		1021,
		9,
		598
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1364;
module.exports = webpackAsyncContext;